export const tokens = {
	device_xl: '1200px',
	device_l: '992px',
	device_m: '768px',
	device_s: '576px',
	device_xs: '375px',
	shadow_color: 'rgba(52, 60, 88, 0.4)',
	zindex_modal: '1070',
	zindex_fixed: '1030',
	zindex_modal_backdrop: '1060',
	zindex_sticky: '1020',
	zindex_drawer: '1050',
	zindex_dropdown: '1000',
	zindex_tooltip: '1090',
	zindex_drawer_backdrop: '1040',
	zindex_popover: '1080',

	color_white: '#fff',
	color_ice: '#f7f7f7',
	color_ink: '#1e2124',
	color_ink_light: '#666e75',
	color_ink_lightest: '#c9cccf',
	color_ink_lighter: '#999ea3',
	color_black: '#000',
	color_cielo: '#A5DAED',

	neutral: {
		light: {
			primary: '#FFFFFF',
			secondary: '#F7F7F7',
			tertiary: '#E6E6E6',
		},
		dark: {
			primary: '#000000',
			secondary: '#707070',
			tertiary: '#9F9F9F',
		},
	},

	primary: {
		primary: '#A5DAED',
		secondary: '#1AB0E6',
		tertiary: '#5082C2',
	},

	color_primary: '#5082c2',
	color_primary_lightest: '#b8dae6',
	color_primary_lighter: '#42bbe6',
	color_primary_lightest_select: '#F5F7FA',
	color_primary_lightest_title: '#64778F',
	color_primary_light: '#438de4',
	color_primary_darker: '#02346e',
	color_primary_darkest: '#011f42',

	color_secondary: '#8dc63f',
	color_secondary_lightest: '#ddeec6',
	color_secondary_light: '#9fcf5d',
	color_secondary_lighter: '#b1d77b',
	color_secondary_darkest: '#69a22d',
	color_secondary_darker: '#558e24',
	color_secondary_dark: '#316c11',

	color_secondary_modal: '#ACD475',

	color_success: '#0dc18b',
	color_success_lightest: '#c5f0de',
	color_success_lighter: '#8be2bd',
	color_success_dark: '#12945d',
	color_success_darkest: '#073b25',
	color_success_darker: '#0c633e',
	color_success_light: '#52d49d',

	color_danger: '#eb0000',
	color_danger_light: '#ff7474',
	color_danger_lightest: '#ffd1d1',
	color_danger_lighter: '#ffa2a2',
	color_danger_dark: '#bf3434',
	color_danger_darkest: '#4d1515',
	color_danger_darker: '#802323',

	color_warning: '#ffd642',
	color_warning_lightest: '#fff4d0',
	color_warning_light: '#ffe071',
	color_warning_lighter: '#ffeaa0',
	color_warning_dark: '#bfa031',
	color_warning_darkest: '#4d4014',
	color_warning_darker: '#806b21',

	family: {
		primary: 'Arial',
	},
	font_family_primary: 'Arial',
	color_gray_medium: 'gray',
	color_gray_dark: '#64778F',
};
